import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import type { RootState } from "store"
import type { ITrainingModule } from "types/trainingModuleTypes"

interface TrainingModuleState {
  trainingModules: Array<ITrainingModule>
  currentTrainingModule: ITrainingModule | undefined
}

const initialState: TrainingModuleState = {
  trainingModules: [] as ITrainingModule[],
  currentTrainingModule: undefined,
}

export const trainingModuleSlice = createSlice({
  name: "trainingmodule",
  initialState,
  reducers: {
    setTrainingModules: (state, action: PayloadAction<Array<ITrainingModule>>) => {
      state.trainingModules = action.payload
    },
    setCurrentTrainingModule: (state, action: PayloadAction<ITrainingModule>) => {
      state.currentTrainingModule = action.payload
    },
    addTrainingModule: (state, action: PayloadAction<ITrainingModule>) => {
      state.trainingModules?.push(action.payload)
    },
    updateTrainingModule: (state, action: PayloadAction<ITrainingModule>) => {
      var index = state.trainingModules.findIndex((x) => x.id === action.payload.id)

      if (index !== -1) {
        state.trainingModules[index] = action.payload
      }
    },
    removeTrainingModule: (state, action: PayloadAction<ITrainingModule>) => {
      var index = state.trainingModules.findIndex((x) => x.id === action.payload.id)

      if (index !== -1) {
        state.trainingModules.splice(index, 1)
      }
    },
    resetTrainingModule: (state, _action) => {
      state.trainingModules = []
      state.currentTrainingModule = undefined
    },
  },
})

export const {
  setTrainingModules,
  addTrainingModule,
  updateTrainingModule,
  removeTrainingModule,
  setCurrentTrainingModule,
  resetTrainingModule,
} = trainingModuleSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const selectCount = (state: RootState) => state.trainingmodule

export default trainingModuleSlice.reducer
